import { setSessionStorage } from "../../../shared/utils/sessionStorage";
import { ANALYTICS_STORAGE_KEYS, LINK_INFO } from "../../../shared/constants/analytics";
import PlayerConstants from "../../../shared/constants/player";
import { showToastNotification, showPlaybackError } from "../../../App/state/actions";
import { trackMediaEnd } from "../../../shared/analytics/media";
const { ASSET_TYPES } = PlayerConstants;

export const updateStreamReadyToChangeState = (
  preventReadyToChangeStreams,
  isLookbackStream,
  id,
  currentChannelId,
  setAssetId,
  currentChannel,
  setIsReadyToChangeStreams
) => {
  if (preventReadyToChangeStreams.current) {
    preventReadyToChangeStreams.current = false;
    if (isLookbackStream && id === currentChannelId) {
      const asset = currentChannel?.assets?.find((asset) => asset?.assetType?.toLowerCase() === ASSET_TYPES.MASTER);
      setAssetId(asset?.assetId);
    }
  } else {
    setIsReadyToChangeStreams(false);
  }
};

export const toastContentOOHBlocked = (dispatch, outHomeIcon, translate) => {
  translate && dispatch(showToastNotification(translate("message_in_home"), outHomeIcon));
};

export const handleChannelChange = (
  id,
  currentChannelId,
  useRoutePlaybackState,
  isRestartedStream,
  switchLive,
  isLookbackStream,
  exitLookbackMode,
  isLoading,
  dispatch,
  setShowContentLockedOverlay,
  setIsPinLocked,
  setCurrentChannelId,
  itemRowNumber,
  isSwitchChannelRef,
  onSwitchProgramEndSessionRef,
  resetPlayerAttributes,
  haltTransitionSOCU,
  isDynatraceTrackingEnabled
) => {
  haltTransitionSOCU.current = true;
  useRoutePlaybackState.current = false;
  if (isRestartedStream.current) switchLive();
  if (isLookbackStream) exitLookbackMode.current = true;

  isLoading.current = true;
  dispatch(showPlaybackError(null, null));
  setShowContentLockedOverlay(false);
  setIsPinLocked(false);

  if (id !== currentChannelId) {
    setCurrentChannelId(id);
    const currentHash = window.location.hash;
    const updatedHash = currentHash.replace(
      currentHash.substring(currentHash.indexOf("?"), currentHash.length),
      `?stationId=${id}&contentType=LIVE`
    );
    window.history.replaceState({}, currentHash, updatedHash);
  }

  if (typeof itemRowNumber === "number") {
    setSessionStorage(ANALYTICS_STORAGE_KEYS.LINK, LINK_INFO.MINI_GUIDE);
    setSessionStorage(ANALYTICS_STORAGE_KEYS.FINDING_METHOD, LINK_INFO.MINI_GUIDE);
  }

  isSwitchChannelRef.current = true;
  if (onSwitchProgramEndSessionRef.current) {
    onSwitchProgramEndSessionRef.current.onSwitchProgramEndConvivaSession();
    trackMediaEnd(null, isDynatraceTrackingEnabled);
  }
  resetPlayerAttributes(isDynatraceTrackingEnabled);
};
